import { render, staticRenderFns } from "./ObservacionesResultadoC3DialogComponent.vue?vue&type=template&id=5e850228&scoped=true"
import script from "./ObservacionesResultadoC3DialogComponent.vue?vue&type=script&lang=js"
export * from "./ObservacionesResultadoC3DialogComponent.vue?vue&type=script&lang=js"
import style0 from "./ObservacionesResultadoC3DialogComponent.vue?vue&type=style&index=0&id=5e850228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e850228",
  null
  
)

export default component.exports